import "../Styles/main.scss";
import "../../components/cmsShared";
import "./index.scss";

//产品分类
//点击“全部分类”箭头展开
//展开分类后背景不能滚动
const $body = $("html, body");
const $arrowButton = $(".product-category__header-right");
const $catList = $(".product-category__list-bg");
const $productCat = $(".product-category");
const toggleAllCategory = function () {
    if ($catList.is(":visible")) {
        $body.removeClass("stop-scrolling");
    } else {
        $body.addClass("stop-scrolling");
    }
    $catList.stop().slideToggle(300);
};
$arrowButton.click(function () {
    toggleAllCategory();
    $productCat.toggleClass("product-category--unfold");
});

$(function () {
    const $childCategory = $(".category-list__child-link-active").closest(".category-list__child");
    const $categoryItem = $(".category-list__child-link-active").closest(".category-list__item");
    //点击二级链接跳转页面二级菜单打开，设置选中效果
    if ($childCategory.length) {
        $childCategory.show(300);
        $categoryItem.addClass("category-list__item-unfold");
    }

    //选中的产品类别样式
    const $activeCatItem = $(".category-list__item-link-active");
    $activeCatItem.closest(".category-list__item").addClass("category-list__item--is-active-parent");

    function setupCategory() {
        $(".category-list__item-arrow").click(function () {
            const $this = $(this);
            //展开某一菜单时其他二级菜单闭合
            if ($this.parent("li").siblings("li").find(".category-list__child").is(":visible")) {
                $this
                    .parent("li")
                    .siblings("li")
                    .removeClass("category-list__item-unfold")
                    .find(".category-list__child")
                    .slideUp(300);
            }
            if ($this.siblings(".category-list__child").is(":visible")) {
                $this.closest("li").removeClass("category-list__item-unfold");
            } else {
                $this.closest("li").addClass("category-list__item-unfold");
            }
            //点击一级菜单时当前二级菜单展开（闭合）
            $this.siblings(".category-list__child").slideToggle(300);
        });

        //点击空白区域收起产品分类
        $(".product-category__list-bg").click(function (event) {
            const $target = $(event.target);
            if ($target.is(".product-category__list-bg")) {
                toggleAllCategory();
            }
        });
    }
    setupCategory();
});
